module.exports = __webpack_public_path__ + "img/Logotipo_Dos tintas.a49f1aa4.png";